/*
 * @Author: Suroc
 * @Date: 2024-07-09 18:19:07
 * @LastEditTime: 2024-12-31 11:23:47
 * @Description: zh-CN多语言配置
 */
// src/i18n/index.js
import { createI18n } from 'vue-i18n'

// 导入语言包
import en from './locales/en'
import zh from './locales/zh'
import ke from './locales/ke'
import jp from './locales/jp'
import ba from './locales/ba'
import ti from './locales/ti'

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 关闭 legacy 模式，启用组合式 API
  locale: localStorage.getItem('i18nLocale') || 'en', // 设置默认语言
  fallbackLocale: 'en', // 设置回退语言
  globalInjection: true,  // 全局注入 $t 函数
  messages: {
    en,
    zh,
    ke,
    jp,ba,ti,
  },
  warnHtmlMessage: false // 防止使用v-html=“$t(“”)”的xss警告
})

export default i18n
